export function isPmaxOverloadedError(errorCode: string) {
    return errorCode === "KT-FR-8926" // KT_FR_8926_MAX_EXECUTION_TIME_REACHED
}
